<template>
  <div id="main">
    <Header></Header>
    <div class="page-container">
      <div class="content-wrapper">
        <router-view></router-view>
      </div>
      <Footer></Footer>
      <Sidebar></Sidebar>
    </div>
  </div>
</template>
<script>
import Header from "./shared/Header";
import Footer from "./shared/Footer";
import Sidebar from "./shared/Sidebar";

export default {
  components: {
    Header,
    Sidebar,
    Footer
  }
};
</script>
<style >
</style>


// WEBPACK FOOTER //
// src/pages/Home.vue